var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLobsters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Lobste.rs",
    role: "img",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: "15%",
    fill: "#ac130c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m420.955 428.064h-308.597v-23.49c9.85-.296 17.913-1.183 24.189-2.688 12.981-3.332 21.501-10.844 23.88-22.831 1.21-6.585 2.27-15.078 2.27-25.533v-199.802c-1.549-21.164-1.89-43.092-23.906-47.935-5.375-1.478-15.951-2.526-24.915-3.13v-21.005h170.627v21.004c-10.16.296-23.504 1.196-29.78 2.688-23.436 6.18-21.125 32.869-21.004 51.509v183.326c-.874 33.903 8.761 51.76 41.162 57.61 23.315-.202 44.078.403 64.947-3.373 21.596-4.435 39.616-18.895 48.378-36.62 4.784-9.85 10.55-33.018 10.55-45.018h22.24z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLobsters);
export default __webpack_public_path__ + "static/media/lobsters.e282b0caa5eb0385400d74eaebcd6338.svg";
export { ForwardRef as ReactComponent };